import { render, staticRenderFns } from "./ProcessPackingPending.vue?vue&type=template&id=0aaa84f6&scoped=true&"
import script from "./ProcessPackingPending.vue?vue&type=script&lang=js&"
export * from "./ProcessPackingPending.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPackingPending.vue?vue&type=style&index=0&id=0aaa84f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa84f6",
  null
  
)

export default component.exports